module.exports = require('./lib/index')



//////////////////
// WEBPACK FOOTER
// /home/daniel/www/navigator.palladium.cz/node_modules/react-hot-loader/index.js
// module id = ../../../node_modules/react-hot-loader/index.js
// module chunks = 0